import { Component, OnInit } from '@angular/core';
import { MapWidgetComponent } from '../../map-widget/map-widget.component';
import { Router } from '@angular/router';
import { UtilsService, ClientService, ModalService } from '@app/services';
import { I18nPipe } from '@app/shared/pipes/i18n.pipe';
@Component({
  selector: 'app-map-widget-vertical',
  templateUrl: './map-widget-vertical.component.html',
  styleUrls: ['./map-widget-vertical.component.css']
})
export class MapWidgetVerticalComponent extends MapWidgetComponent implements OnInit {

  constructor(
    protected router: Router,
    protected clientService: ClientService,
    protected utils: UtilsService,
    protected i18n: I18nPipe,
    protected modalService: ModalService
  ) {
    super(router, clientService, utils, i18n, modalService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
